// Enterprise form section (max 8-10 fields per section) — see /app/memory/DESIGN_SYSTEM.md §10
import { cn } from '@/lib/utils';

export const FormSection = ({ title, description, children, className, testid }) => (
  <section className={cn('space-y-3', className)} data-testid={testid}>
    <div className="border-b border-zinc-100 pb-1.5">
      <h3 className="text-sm font-semibold text-zinc-900">{title}</h3>
      {description && <p className="text-xs text-zinc-500 mt-0.5">{description}</p>}
    </div>
    <div className="space-y-3">{children}</div>
  </section>
);
